import * as React from 'react';
import { createContext, useReducer } from 'react';
import { bffWebChatReducer, initialWebChatState } from './BFFWebChatState';
export const BFFWebChatContext = createContext(undefined);
export const BFFWebChatContextProvider = ({ styleOptions, children }) => {
    const [state, dispatch] = useReducer(bffWebChatReducer, Object.assign(Object.assign({}, initialWebChatState), { styleOptions: Object.assign(Object.assign({}, initialWebChatState.styleOptions), styleOptions) }));
    const value = { state, dispatch };
    return React.createElement(BFFWebChatContext.Provider, { value: value }, children);
};
//# sourceMappingURL=BFFWebChatContext.js.map